import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export const useNotificationCount = () => {
  const { user } = useAuth();

  const { data: count = 0 } = useQuery({
    queryKey: ['notification-count', user?.id],
    queryFn: async () => {
      if (!user) return 0;
      // Count recent orders with updates in last 24h
      const since = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
      const { count } = await supabase
        .from('orders')
        .select('*', { count: 'exact', head: true })
        .eq('customer_id', user.id)
        .gte('updated_at', since)
        .neq('status', 'delivered');
      return count || 0;
    },
    enabled: !!user,
    refetchInterval: 30000,
  });

  return count;
};
